import { DiscordSDK } from "@discord/embedded-app-sdk";
import EnvVars from "../declarations/major/EnvVars";
import Client from "./network";

let discordSdk: DiscordSDK | undefined = undefined;
try {
    discordSdk = new DiscordSDK(EnvVars.discordClientId);
} catch {
    Client.activity = false;
}

export default discordSdk;
